import type { PlayerProfile } from "@chessla/shared";
import { apiClient } from "@/shared/api/client";

export interface CreatePlayerInput {
  username: string;
  goals: string[];
}

/** Creates a player profile linked to the current authenticated user. */
export const createPlayerProfile = (input: CreatePlayerInput): Promise<PlayerProfile> =>
  apiClient<PlayerProfile>("/chess-com/account", {
    method: "POST",
    body: JSON.stringify(input),
  });
